import { Text } from 'components/Text';
import { MediaAttributeType } from 'graphql/types';
import { classNames } from 'libs/react';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import { Case } from 'components/util/Case';
import { FileName } from 'components/file/FileName';
import { FileSize } from 'components/file/FileSize';
import { FileType } from 'components/file/FileType';
import { MediaViewer } from 'components/media/MediaViewer';
import './MediaInfos.scss';
import { Button } from 'components/Button';
/**
 * @component MediaInfos
 * @since 1.0.0
 */
export function MediaInfos(props) {
    const { style, media, onDelete } = Object.assign({ style: 'normal' }, props);
    const className = classNames('media-infos', 'media-infos--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "media-infos-preview" },
            React.createElement(MediaViewer, { media: media })),
        React.createElement("div", { className: "media-infos-caption" },
            React.createElement(FileName, { className: "media-infos-caption-file-name", value: media.filename }),
            React.createElement(FileType, { className: "media-infos-caption-file-type", value: media.mimetype }),
            React.createElement(FileSize, { className: "media-infos-caption-file-size", value: media.filesize })),
        React.createElement("div", { className: "media-infos-infos" }, media.attributes.map((attribute) => (React.createElement(Fragment, { key: attribute.type },
            React.createElement(Case, { is: attribute.type == MediaAttributeType.Width },
                React.createElement("div", { key: "width", className: "media-infos-info" },
                    React.createElement(Text, { className: "media-infos-info-label", value: t('Width') }),
                    React.createElement(Text, { className: "media-infos-info-value", value: attribute.data, suffix: "px", ellipsize: true }))),
            React.createElement(Case, { is: attribute.type == MediaAttributeType.Height },
                React.createElement("div", { key: "height", className: "media-infos-info" },
                    React.createElement(Text, { className: "media-infos-info-label", value: t('Height') }),
                    React.createElement(Text, { className: "media-infos-info-value", value: attribute.data, suffix: "px", ellipsize: true }))),
            React.createElement(Case, { is: attribute.type == MediaAttributeType.Duration },
                React.createElement("div", { key: "duration", className: "media-infos-info" },
                    React.createElement(Text, { className: "media-infos-info-label", value: "Duration" }),
                    React.createElement(Text, { className: "media-infos-info-value", value: attribute.data, suffix: "s", ellipsize: true }))))))),
        React.createElement(Button, { style: "warning", label: t('Delete'), picto: "trash", onPress: onDelete })));
}
